import { Badge } from '@mantine/core';

import { TrackableObjectType } from 'types/trackables';

import { TRACKABLE_OBJECT_TYPE_LABELS } from '../../utils';

interface TrackableListsTableObjectTypeCellProps {
  objectType: TrackableObjectType;
}

const OBJECT_TYPE_COLORS: Record<TrackableObjectType, string> = {
  face: 'blue',
  vehicle: 'green',
  custom: 'yellow',
};

export function TrackableListsTableObjectTypeCell({
  objectType,
}: TrackableListsTableObjectTypeCellProps) {
  return (
    <Badge color={OBJECT_TYPE_COLORS[objectType]}>
      {TRACKABLE_OBJECT_TYPE_LABELS[objectType]}
    </Badge>
  );
}
